export default "__VITE_ASSET__a482e4ab__"